// extracted by mini-css-extract-plugin
export default {"root":"styles_root__PA6NK","flip":"styles_flip__pHkyZ","label":"styles_label__QlQ+-"};